import { render, staticRenderFns } from "./AppTimeline.vue?vue&type=template&id=24bbd622&scoped=true&"
import script from "./AppTimeline.vue?vue&type=script&lang=js&"
export * from "./AppTimeline.vue?vue&type=script&lang=js&"
import style0 from "./AppTimeline.vue?vue&type=style&index=0&id=24bbd622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bbd622",
  null
  
)

export default component.exports